import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { navLinks, contact } from '../data/site';
import { useLanguage } from '../contexts/LanguageContext';
import { GlowButton } from './motion/GlowButton';
import { LanguageSwitcher } from './LanguageSwitcher';
import { Logo } from './Logo';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-white/10 bg-[#07051A]/85 backdrop-blur-xl' : 'border-b border-transparent'}`} data-id="element-132" data-mp="9mntsk5pwi3l">
      <nav aria-label="Main" className="mx-auto flex h-20 w-full max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-133" data-mp="9p95q3w5w142">
        <a href="#home" aria-label={t.nav.backToTop} className="inline-flex" data-id="element-134" data-mp="elpvf2j0enj9">
          <Logo className="h-9 sm:h-11" data-id="element-135" data-mp="jnynzxryznku" />
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-136" data-mp="olgp51zqwyia">
          {navLinks.map((link, i) => <li key={link.href} data-id="element-137" data-mp="3n3mbas0dv4hp" data-mpi={i}>
              <a href={link.href} className="group relative text-sm font-medium uppercase tracking-[0.12em] text-white/70 transition-colors hover:text-white" data-id="element-138" data-mp="3n4fbfa4u6vqv">
                {t.nav.links[i]}
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-magenta shadow-glow-magenta transition-all duration-300 group-hover:w-full" data-id="element-139" data-mp="ub9amtt267z" />
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-140" data-mp="39bzcoliyxjvr">
          <LanguageSwitcher className="hidden sm:inline-flex" data-id="element-141" data-mp="39ao8iklm2a44" />
          <GlowButton href={contact.bookingHref} className="hidden rounded-full bg-magenta px-6 py-3 font-display text-xs font-extrabold uppercase tracking-[0.16em] text-white shadow-glow-magenta transition-shadow duration-300 hover:shadow-[0_0_60px_-6px_rgba(236,30,156,0.9)] sm:inline-block" data-id="element-142" data-mp="31b03orpccqvr">
            {t.nav.book}
          </GlowButton>
          <motion.button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? t.nav.closeMenu : t.nav.openMenu} whileTap={{
          scale: 0.92
        }} transition={{
          type: 'spring',
          stiffness: 420,
          damping: 24
        }} className="rounded-full border border-white/15 p-2.5 text-white transition-colors hover:border-magenta/60 hover:text-magenta lg:hidden" data-id="element-143" data-mp="364cg83gqx785">
            {open ? <XIcon className="h-5 w-5" data-id="element-144" data-mp="7ijbg9c7bz8s" /> : <MenuIcon className="h-5 w-5" data-id="element-145" data-mp="2l9nky4gnvn2" />}
          </motion.button>
        </div>
      </nav>

      <AnimatePresence data-id="element-146" data-mp="a4scfl0dyj3k">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="overflow-hidden border-t border-white/10 bg-[#07051A]/95 backdrop-blur-xl lg:hidden" data-id="element-147" data-mp="a3r4vqikweql">
            <ul className="flex flex-col gap-1 px-5 py-5" data-id="element-148" data-mp="sva37k1nr4ma">
              {navLinks.map((link, i) => <li key={link.href} data-id="element-149" data-mp="xud7h29td6t7" data-mpi={i}>
                  <a href={link.href} onClick={() => setOpen(false)} className="block rounded-xl px-4 py-3 text-sm font-semibold uppercase tracking-[0.14em] text-white/80 transition-colors hover:bg-white/5 hover:text-white" data-id="element-150" data-mp="xtbmo62zx5ya">
                    {t.nav.links[i]}
                  </a>
                </li>)}
              <li className="flex justify-center pt-3 sm:hidden" data-id="element-151" data-mp="1glw9p6w0kgu6">
                <LanguageSwitcher data-id="element-152" data-mp="3p1nn7i5c2l4h" />
              </li>
              <li className="pt-2" data-id="element-153" data-mp="3p3i5eop7zz4v">
                <a href={contact.bookingHref} target="_blank" rel="noopener noreferrer" className="block rounded-full bg-magenta px-6 py-3.5 text-center font-display text-xs font-extrabold uppercase tracking-[0.16em] text-white shadow-glow-magenta" data-id="element-154" data-mp="3k2u7rk6hkk1o">
                  {t.nav.book}
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}